<div class="search-input">
  <input
    [type]="type"
    [formControl]="control"
    class="form-control"
    [placeholder]="placeholder"
  />
  <icon type="search"></icon>
</div>
